var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel", attrs: { id: "panel-4" } }, [
    _c("div", { staticClass: "panel-hdr" }, [
      _c("h2", [
        _vm._v(
          "\n            " +
            _vm._s(_vm.__t("ORGANIZATIONS_LIST")) +
            "\n            "
        ),
        _c("sup", [
          _c("span", { staticClass: "badge badge-warning ml-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t(this.provider_type.toUpperCase())) +
                "\n                "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-toolbar" }, [
        _vm.has_head_action
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-sm btn-info mr-1 shadow-0 waves-effect waves-themed",
                on: { click: _vm.head_action },
              },
              [
                _vm.show_head_action_title
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          this.provider_type.toUpperCase() + _vm.__t("PROV")
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("i", { class: _vm.head_action_icon }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.has_settings
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-sm btn-success shadow-0 waves-effect waves-themed",
                on: { click: _vm.show_base_settings },
              },
              [
                _vm._v("\n                " + _vm._s(_vm.__t("BASE")) + "  "),
                _c("i", { staticClass: "fal fa-cog" }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-container show pt-3 pb-5" }, [
      _c(
        "div",
        { staticClass: "panel-content" },
        [
          _vm.percent_add > 0
            ? _c("div", { staticClass: "pb-3" }, [
                _c("div", { staticClass: "percent_info" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.__t("PERCENT_ADD")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "progress progress-lg mr-3 width-sm rounded bg-warning-200",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress-bar",
                        staticStyle: { width: "75%" },
                        attrs: { role: "progressbar", "aria-valuemax": "100" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.percent_add) + "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
            _c("div", { staticClass: "rounded" }, [
              _vm.organizations.length > 0
                ? _c(
                    "ul",
                    { staticClass: "nav-menu mb-sm-4 mb-md-0 rounded" },
                    _vm._l(_vm.organizations, function (org) {
                      return _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.set_active(org)
                            },
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "waves-effect waves-themed pl-1 pr-1",
                              class: { active_filter: _vm.is_active_org(org) },
                            },
                            [
                              org.published
                                ? _c(
                                    "strong",
                                    { staticClass: "dl-ref bg-success-500" },
                                    [
                                      _vm._v(
                                        "\n                                    active\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !org.published
                                ? _c(
                                    "strong",
                                    {
                                      staticClass: "dl-ref bg-danger-500",
                                      on: {
                                        click: function ($event) {
                                          if (
                                            $event.target !==
                                            $event.currentTarget
                                          ) {
                                            return null
                                          }
                                          return _vm.set_active(org)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.__t("unpiblished")) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "nav-link-text color-black" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(org.title) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.add_location(org)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fal fa-plus" })]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }